export enum QuestionType {
  Undefined = 'Undefined',
  Textarea = 'Textarea',
  Input = 'Input',
  Datepicker = 'Datepicker',
  Dropdown = 'Dropdown',
  RadioButton = 'RadioButton',
  InputTable = 'InputTable',
  Repeater = 'Repeater',
  Checkbox = 'Checkbox',
  Information = 'Information',
  FileUpload = 'FileUpload',
  Worksite = 'Worksite',
  Person = 'Person',
  Classification = 'Classification',
  Budget = 'Budget',
  GlobalGoals = 'GlobalGoals',
  SarskildaVillkor = 'SarskildaVillkor',
  DatepickerChangeRequest = 'DatepickerChangeRequest',
  Signering = 'Signering',
}
